import { Config as ApiSDKConfig } from '@utex/base-api-sdk';
import { MenuProps } from '../components/MenuItem';
import { SelectProps } from '../components/SelectItem';
import { TabSchema } from '../hooks/useTabs/mapping';
import { ClearingDepositInstrumentType } from './gql';

export interface AppConfig {
  utcomGateway: ApiSDKConfig;
  graphqlGateway: { url: string };
  utexWallet?: { url: string };
}

// popup ProviderWalletTransfer types
export type InstrumentType = ClearingDepositInstrumentType | 'PAYEER' | 'ADVCASH';

export type Currency = 'USD' | 'RUB' | 'UTT';

export type InstrumentId = `${InstrumentType}_${Currency}`;

export interface ContentProps<T extends InstrumentId = InstrumentId> {
  available: TabSchema<T>[];
}

export interface InstrumentComponents<T extends InstrumentId = InstrumentId> {
  Menu: React.FC<MenuProps>;
  Content: React.FC<ContentProps<T>>;
  Select: React.FC<SelectProps>;
}

export interface InstrumentSchema<T extends InstrumentId = InstrumentId> {
  supports: Set<T>;
  components: InstrumentComponents<T>;
}

export interface InstrumentParams {
  minimum: number;
  maximum: number;
  fee: number;
  paymentSystemId: number | undefined;
}
